<template>
    <div>
        <h3 class="is-size-3">INEGI Geoestadisticas por Código</h3>
        <p>
            <code>POST {{ host }}/api/inegiLocationById</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint tiene dos parámetros:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>inegiCode</strong>
                    <ul>
                        <li>Requerido</li>
                        <li>Formato (Ej. 080190001)</li>
                    </ul>
                </li>
                <li>
                    <strong>Descripción del código</strong>
                    <ul>
                        <li>Del 1 al 2 son el Estado - 08</li>
                        <li>Del 3 al 5 son el Municipio - 019 </li>
                        <li>Del 6 al 9 son la Localidad - 0001 </li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">
            El endpoint recibe la solicitud en formato JSON:
        </h5>
        <pre>
        <code>
            {
                "inegiCode": "080190001"
            }
        </code>
        </pre>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>
            [
                {
                    "inegiLocationCode": "080190001",
                    "stateCode": "08",
                    "muncipalityCode": "019",
                    "locationCode": "0001",
                    "locationName": "Chihuahua",
                    "locationType": "URBANO",
                    "latitud": "28.6367939",
                    "longitud": "-106.0763067",
                    "altitud": "1424",
                    "population": 925762,
                    "household": 296779
                }
            ]
        </code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>